import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppCommonModule } from '@common/app-common.module';
import { CustomTableModule } from '@modules/custom-table/custom-table.module';
import { DashboardModule } from '@modules/dashboard/dashboard.module';
import { NavigationModule } from '@modules/navigation/navigation.module';
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';

import * as invoiceUploaderComponents from './components';
import * as invoiceUploaderContainers from './containers';
import * as invoiceUploaderGuards from './guards';
import * as invoiceUploaderServices from './services';
// import { SBDescriptionComponent } from '../common/dp.component';
// import { SBActionDescriptionComponent } from '../common/adp.component';

/* Modules */

/* Components */

/* Containers */

/* Guards */

/* Services */

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        AppCommonModule,
        NavigationModule,
        UploaderModule,
        // DashboardModule,
        CustomTableModule,
    ],
    providers: [...invoiceUploaderServices.services, ...invoiceUploaderGuards.guards],
    declarations: [
        ...invoiceUploaderContainers.containers,
        ...invoiceUploaderComponents.components,
    ],
    exports: [...invoiceUploaderContainers.containers, ...invoiceUploaderComponents.components],
})
export class InvoiceUploaderModule {}
